import React, { useState, useEffect } from 'react';

import './styles.css';

import callListServices from '../../../../services/academy/callListServices';

import { months } from '../../../../functions/formatDate';
import compare from '../../../../functions/compare';

import { Dots } from 'react-activity';

import Popup from '../../../../components/Popup';
import SelectGroup from '../../../../components/SelectGroup';
import UserPhoto from '../../../../components/UserPhoto';
import { FaUserCheck } from 'react-icons/fa';

function PopupCheckout(props) {
    const [selectList, setSelectList] = useState([]);
    const [backupList, setBackupList] = useState([]);
    const [blockedList, setBlockedList] = useState([]);
    const [hideList, setHideList] = useState([]);
    const [fetching, setFetching] = useState(false);
    const dateTime = props.data ? props.data.data.split('-').reverse() : null;

    useEffect(() => {
        if (props.data && props.visibility) {
            const alunos = props.data.alunos.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`));
            setSelectList(alunos.map((item, index) => item.presenca.check_out ? index : -1).filter((item) => item !== -1));
            setBackupList(alunos.map((item, index) => item.presenca.check_out ? index : -1).filter((item) => item !== -1));
            setBlockedList(alunos.map((item, index) => item.presenca.check_out ? index : -1).filter((item) => item !== -1));
            setHideList(alunos.map((item, index) => item.presenca.check_in === false ? index : -1).filter((item) => item !== -1));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data, props.visibility]);

    async function updateCallListCheckouts() {
        setFetching(true);
        const response = await callListServices.postGroupCheckout(props.data.turma.id, props.data.id, selectList.map((item) => ({ "aluno": props.data.alunos[item].id })));
        setFetching(false);
        if (response.status === 204) {
            props.onUpdate();
            props.setVisibility(false);
        } else
            alert("Erro ao registrar checkout, verifique a lista e tente novamente!");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaUserCheck />}
            tittle='Checkout'
        >
            <span className='popup-checkout-tag'>
                {props.data ? props.data.atividade : 'Sem tipo'} - {props.data ? `${dateTime[0]} de ${months[Number(dateTime[1]) - 1]} de ${dateTime[2]} às ${props.data.hora.slice(0, 5)}` : "Data e hora não especificada"}
            </span>
            <SelectGroup
                checkMode
                showInfos
                contMarkeds
                showSelectAll={props.data && props.data.alunos.length !== (backupList.length + hideList.length)}
                tittle='Alunos'
                itemType='checkouts'

                markeds={selectList}
                blockeds={blockedList}
                hides={hideList}
                setMarkeds={setSelectList}
            >
                {
                    props.data ?
                        props.data.alunos.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`)).map((item, index) =>
                            <div key={item.id} className='popup-checkout-select-group'>
                                <UserPhoto src={item.foto} />
                                <p><b>{`${item.nome} ${item.sobrenome}`}</b></p>
                            </div>
                        )
                        : []
                }
            </SelectGroup>

            {
                props.data && props.data.alunos.length !== (backupList.length + hideList.length) ?
                    <button
                        onClick={() => {
                            if (selectList.sort().toString() === blockedList.sort().toString())
                                alert("Os alunos selecionados já estão com checkout registrado.");
                            else
                                updateCallListCheckouts();
                        }}
                    >{
                            fetching ?
                                <Dots />
                                : "Registrar checkout"}
                    </button>
                    : []
            }
        </Popup>
    )
}

export default PopupCheckout;